module.exports = __webpack_public_path__ + "img/vertical_2_1_7042.3e4ea702.png";